import { render } from "./MyTitle.vue?vue&type=template&id=28e55d9e&scoped=true&ts=true"
import script from "./MyTitle.vue?vue&type=script&lang=ts"
export * from "./MyTitle.vue?vue&type=script&lang=ts"

import "./MyTitle.vue?vue&type=style&index=0&id=28e55d9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e55d9e"]])

export default __exports__